import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Card, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import global from '../global';
import { config } from '../../Constants';
import { Layout } from '../Layout';
import Spinner from '../Spinner';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import download from 'downloadjs'
const { SearchBar } = Search;


export class FetchBeneficiary extends Component {
    displayName = 'Shareholder'

    constructor(props) {
        super(props);
        this.state = {
            Beneficiarys: [],
            URL: config.url.API_URL,
            columns: [{
                dataField: 'BeneficiaryID',
                text: 'Beneficiary ID',
                hidden: true
            },
                {
                    dataField: 'RN',
                    text: '#',
                    headerAlign: 'center',
                    align: 'center',
                    headerStyle: (colum, colIndex) => {
                        return { width: '5%', textAlign: 'center' };
                    },
                },
                {
                    dataField: 'RemitterName',
                    text: 'Company',
                    sort: true,
                    headerAlign: 'center',
                    headerStyle: (colum, colIndex) => {
                        return { width: '20%', textAlign: 'center' };
                    },
                },
            {
                dataField: 'BeneficiaryName',
                text: 'Shareholder',
                headerAlign: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '20%', textAlign: 'center' };
                },
                }, {
                    dataField: 'EmailID',
                    text: 'Email',
                    sort: true,
                    headerAlign: 'center'
                }, {
                dataField: 'PAN',
                text: 'PAN',
                headerAlign: 'center',
                sort: true,
            },
            {
                dataField: 'DPID',
                text: 'DP ID',
                sort: true,
                headerAlign: 'center'

            },
            {
                dataField: 'RemitterID',
                text: 'remitterID',
                hidden: true,
                headerAlign: 'center'
            },
            
            
                
            {
                dataField: "Action",
                text: "Action",
                align: 'center',
                headerAlign: 'center',
                formatter: (rowContent, row) => {

                    return (
                        <div>
                            <button className="btn btn-warning p-10" title="View"
                                onClick={e => {
                                    e.persist();
                                    FetchBeneficiary.handleView(row.BeneficiaryID, this.state.URL)
                                }}> <FontAwesomeIcon icon="eye" /></button>
                        </div>
                    )
                    
                }
            }
            ],
            RemitterCode: '',
            loading: false
        };
        this.initialState = this.state;
    }

    componentDidMount() {
        debugger
        axios.get(global.Beneficiary.GetBeneficiaryDetailsAPI,
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } },
            { responseType: 'json' })
            .then(response => {
                if (response.status) {

                    this.setState({
                        Beneficiarys: response.data.data
                    });
                }
                else {
                    this.setState({
                        Beneficiarys: []
                    });
                }



            })
            .catch(error => {
                console.log(error);
            });
    }

    static handleEdit(beneficiaryID, remitterID, URL) {
        //window.location.href = URL + `Nexdigm/View-Shareholder?bD=` + window.btoa(beneficiaryID) + '&module=MB&Type=' + window.btoa('E');
        window.location.href =  `Nexdigm/View-Shareholder?bD=` + window.btoa(beneficiaryID) + '&module=MB&Type=' + window.btoa('E');

    }

    static handleView(beneficiaryID, remitterID, URL) {
        //window.location.href = URL + `Nexdigm/View-Shareholder?bD=` + window.btoa(beneficiaryID) + '&module=MB&Type=' + window.btoa('V');
        window.location.href =  `Nexdigm/View-Shareholder?bD=` + window.btoa(beneficiaryID) + '&module=MB&Type=' + window.btoa('V');

    }

    handleExport = (e) => {
        e.preventDefault();
        this.setState({ loading: true });

        axios.get(global.Beneficiary.ExportBeneficiaryDetailsAPI,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/xlsx' },
                responseType: 'blob'
            })
            .then(response => {
                if (response) {
                    this.setState({ loading: false });

                    const content = response.headers['content-type'];
                    const fileName = "ShareholderDetails.xlsx";

                    download(response.data, fileName, content);
                }
                else {
                    this.setState({ loading: false });                    
                }
            })
            .catch(error => {
                this.setState({ loading: false });

            });

    }

    render() {
        if (this.state.loading) return <Spinner />;
        const options = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.Beneficiarys.length
        };

        const contentTable = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="BeneficiaryID"
                    columns={this.state.columns}
                    data={this.state.Beneficiarys}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <SearchBar {...toolkitprops.searchProps} />
                                <div className="m-t-10">
                                    <BootstrapTable
                                        
                                        hover
                                        {...toolkitprops.baseProps}
                                        {...paginationTableProps}
                                        wrapperClasses="table-responsive"  />
                                </div>
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        let content = Layout.RenderNavMenu()
        return (
            <div>
                {content}
                <div className="Nexdigm">
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><a href={this.state.URL + "/Nexdigm/Dashboard"} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a className="text-white">Shareholder Details</a></li>
                    </ol>
                </div>
                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="header-title">Shareholder Details</h4>
                            <button className="btn btn-primary float-right m-r-10 m-b-10" onClick={this.handleExport}> Export </button>
                            <PaginationProvider
                                pagination={
                                    paginationFactory(options)
                                }
                            >
                                {contentTable}
                            </PaginationProvider>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}
